import get_router from "./router"
import urls, { DEFAULT_VIEW } from "./urls"

export default (name = DEFAULT_VIEW, params = {}) => {
  const route_def = urls[name] as { navigate: (p: object) => string }
  const path = route_def.navigate(params)

  if (name === DEFAULT_VIEW) {
    history.replaceState(
      "",
      document.title,
      window.location.pathname + window.location.search
    )
    // Trigger a hashchange-like resolution
    get_router().push("/")
  } else {
    get_router().push(path)
  }
}
